import axios from '../../api/vue-axios/axios'
import store from '../../store'
import stringHelper from '@/helpers/stringHelper'

const state = {
  scriptProductLinks: []
}

const mutations = {
  setScriptProductLinks (state, productLinks) {
    state.scriptProductLinks = productLinks
  },
  addScriptProductLink (state, productLink) {
    state.scriptProductLinks.push(productLink)
    // TODO: Sort here?
  },
  removeScriptProductLink (state, productLink) {
    let index = state.scriptProductLinks.findIndex((p) => { return p.id === productLink.id })
    state.scriptProductLinks.splice(index, 1)
  }
}

const getters = {
  scriptProductLinks (state) {
    return state.scriptProductLinks   // TODO sort??
  }
}

const actions = {
  getScriptProductLinks (context) {
    return axios.get('users/' + store.getters.currentUser.id + '/scripts/' + store.getters.script.id + '/product_links')
      .then((response) => {
        let product_links = stringHelper.camelizeArrayOfObjects(response.data.product_links)
        context.commit('setScriptProductLinks', product_links)
      })
  },
  addScriptProductLink (context, productLink) {
    context.commit('addScriptProductLink', productLink)
  },
  addScriptProductLinks (context, productLinks) {
    productLinks.forEach((productLink) => {
      context.commit('addScriptProductLink', productLink)
    })
  },
  removeScriptProductLinks (context, productLinks) {
    productLinks.forEach((productLink) => {
      context.commit('removeScriptProductLink', productLink)
    })
  },
  removeScriptProductLink (context, productLink) {
    context.commit('removeScriptProductLink', productLink)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/scriptProductLinks.js